import type { SxProps } from "@mui/material"

const avatarContainer: SxProps = {
  "& .MuiBadge-dot": {
    height: 13,
    minWidth: 13,
    borderRadius: 10
  }
}

const avatar: SxProps = {
  width: 32,
  height: 32
}

const navigationRow: SxProps = { color: "#4D4D4D", cursor: "pointer" }

export default { avatarContainer, navigationRow, avatar }
